import { all } from "redux-saga/effects";
import {
  addStrAccWatcher,
  addStrBrandSoftwareWatcher,
  addStrDispatchWatcher,
  addStrFollowUpWatcher,
  addStrInfraWatcher,
  addStrOpeningWatcher,
  addStrbrandWatcher,
  deleteItemWatcher,
  storeAddressCreateWatcher,
  storeAddressUpdateWatcher,
  storeAgreementCreateWatcher,
  storeDrugCreateWatcher,
  storeFirmCreateWatcher,
  storePartnerCreateWatcher,
  storeLOICreateWatcher,
  getFofoStoreTypesWatcher,
  getFofoFirmTypesWatcher,
  storePaymentCreateWatcher,
  storePersonalCreateWatcher,
  storeTableWatcher,
  strExeGetWatcher,
  strFollowUpGetWatcher,
} from "../store-saga";

export default function* storeRootSaga() {
  yield all([
    deleteItemWatcher(),
    storeAddressCreateWatcher(),
    storePersonalCreateWatcher(),
    storeFirmCreateWatcher(),
    storePartnerCreateWatcher(),
    storeAgreementCreateWatcher(),
    storePaymentCreateWatcher(),
    storeDrugCreateWatcher(),
    storeLOICreateWatcher(),
    getFofoStoreTypesWatcher(),
    getFofoFirmTypesWatcher(),
    storeAddressUpdateWatcher(),
    storeTableWatcher(),
    addStrInfraWatcher(),
    addStrbrandWatcher(),
    addStrBrandSoftwareWatcher(),
    addStrAccWatcher(),
    addStrDispatchWatcher(),
    addStrOpeningWatcher(),
    addStrFollowUpWatcher(),
    strFollowUpGetWatcher(),
    strExeGetWatcher(),
  ]);
}
